module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-toast-alcohol-59cfa5eaee54c5bc510392ddf9bbce48.png";